import { Page } from './page';

export class PageSession {

    private page: Page;
    private browsingSessionId: string;

    private _id: string;
    private _referrer: string;

    constructor(id: string, browsingSessionId: string, title: string, href: string, domain: string, query: string) {
        this._id = id;
        this.browsingSessionId = browsingSessionId;
        this.page = new Page();
        this.page.title = title;
        this.page.uri = href;
        this.page.domain = domain;
        this.page.query = query;
    }

    get id(): string {
        return this._id;
    }

    get referrer(): string {
        return this._referrer;
    }

    set id(id: string) {
        this._id = id;
    }

    set referrer(referrer: string) {
        this._referrer = referrer;
    }
}
